import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const DeliverySupport = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        ডেলিভারি সাপোর্ট
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          এখানে ডেলিভারি সংক্রান্ত সমস্যা এবং সাপোর্ট দেখানো হবে।
        </Typography>
      </Paper>
    </Box>
  );
};

export default DeliverySupport; 